<template>
    <div id="merge">
        <div id="update">
            <div class="update_box">
                <uploadFile :allowFileType="['doc', 'docx']" footnote="将原文文件拖到此处，" @changeUploadEvent="uploadSectionFile1"/>
            </div>

            <div class="update_box2">
                <uploadFile :allowFileType="['doc', 'docx']" footnote="将译文文件拖到此处，" @changeUploadEvent="uploadSectionFile2"/>
            </div>
        </div>
        <div id="submit_btn">
            <el-button class="button_submit" type="primary" round :loading="reading" @click="submitForm()">上传</el-button>
        </div>

        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
            <span>是否打开最近的项目：{{fileName}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="remove()">取 消</el-button>
                <el-button type="primary" @click="jump()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import uploadFile from "../components/uploadFile";

    export default {
        components:{uploadFile},
        data(){
            return{
                ruleForm: {
                    file:'',        // 提交表单的原文
                    file2:'',       // 提交表单的译文
                },
                reading: false,     // 上传按钮加载动画
                centerDialogVisible: false,     // 显示历史记录弹窗开关
                fileName:'',        // 历史记录文件名称
                doc_id: '',         // 历史记录文件id
            }
        },
        methods:{
            uploadSectionFile1: function(param) {
                this.ruleForm.file = param.file;
            },
            uploadSectionFile2: function(param) {
                this.ruleForm.file2 = param.file;
            },
            submitForm(){
                if(this.ruleForm.file != '' && this.ruleForm.file2 != ''){
                    // 获取 生成 表单
                    let source = this.ruleForm.file;
                    let translate = this.ruleForm.file2;
                    let param = new FormData();
                    param.append("source", source);
                    param.append("translate", translate);
                    // 发送上传请求
                    var _this = this;
                    _this.reading = true;
                    _this.$message({message:'请稍候，文档正在处理中...  即将为您跳转至编辑页面~', duration:1111});
                    _this.$axios.post('/merge/', param)
                        .then(function(response){
                            if(response.data.code === 0){
                                window.location.href = '/doc_merge/html/detail?doc_id='+response.data.data.doc_id
                            }
                        })
                        .catch(error=>{
                            console.log(error)
                        })
                }else if(this.ruleForm.file == ''){
                    this.$message({
                        message: '请上传 原文 文件',
                        type: 'warning'
                    });
                }else if(this.ruleForm.file2 == ''){
                    this.$message({
                        message: '请上传 译文 文件',
                        type: 'warning'
                    });
                }
            },
            jump(){
                this.centerDialogVisible = false;
                window.location.href = '/doc_merge/html/detail?doc_id='+this.doc_id
            },
            remove(){
                this.centerDialogVisible = false;
                localStorage.removeItem('lately')
            },
        },
        mounted(){
            try{
                let lately = JSON.parse(window.localStorage.getItem('lately'));
                let fileName = lately.file_name;
                let doc_id = lately.doc_id;
                this.fileName = fileName;
                this.doc_id = doc_id;
                this.centerDialogVisible = true;
            }catch{
                // console.log(null)
            }
        }
    }
</script>

<style scoped>
    #merge{
        width: 1000px;
        background-color: #fff;
        border-radius: 3px;
        margin: 0 auto;
    }
    #update{
        width: 800px;
        height: 500px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .update_box,
    .update_box2{
        width: 360px;
    }
    #submit_btn{
        clear: both;
        width: 150px;
        height: 50px;
        margin: 0px auto;
        padding-bottom: 100px;
    }
    .button_submit{
        width: 150px;
        height: 50px;
    }
</style>
